import React, { useState } from 'react';
import { flushSync } from 'react-dom';
import { Container, Button, Form } from 'react-bootstrap';
import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useLoading } from '../../context/LoadingContext';
import { useTracking } from '../../context/TrackingContext';
import { generateUniqueId, useStateWithSentry } from '../../utilities/common';
import { validateAndScroll } from '../intake_new/intake-utilities';
import {
  isValidPhoneNANP,
  normalizePhoneNANP,
  savePatientStoryData
} from './patient-story-utilities';
import PatientStoryContactForm from './DemoForms/PatientStoryContactForm';
import '../../styles/intakeNew.scss';

export default function PatientStoryFormContainer() {
  const [formData, setFormData] = useStateWithSentry('formData', {
    name_first: '',
    name_last: '',
    email: '',
    phone: '',
    want_contact: ''
  });

  const [showFormErrors, setShowFormErrors] = useState(false);
  const { setIsLoading } = useLoading();
  const userTracking = useTracking();

  const handleSubmit = async e => {
    e.preventDefault();
    toast.dismiss();

    const rawPhone = formData.phone;
    const phoneForSubmit = isValidPhoneNANP(rawPhone)
      ? normalizePhoneNANP(rawPhone)
      : rawPhone;

    if (!validateAndScroll(e.target, setShowFormErrors)) {
      return;
    }
    setShowFormErrors(false);
    setIsLoading(true);
    try {
      const blobPath = `${import.meta.env.VITE_PATIENT_STORY_FILE_PATH}`;
      const specificBlobName = generateUniqueId();
      const updatedFormdata = {
        ...formData,
        phone: phoneForSubmit,
        ...userTracking
      };
      await savePatientStoryData({
        formData: updatedFormdata,
        blobPath,
        specificBlobName,
        userTracking
      });
      await axios.post(
        `${import.meta.env.VITE_APP_VENNAPLAN_API_BASE_URL}/send_email/send_patient_story_email/`,
        {
          formData: updatedFormdata,
          recipient_emails: import.meta.env.VITE_PATIENT_STORY_RECIPIENT_EMAIL.split(',')
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      window.top.location.href =
        'https://www.hannamfertility.com/thank-you-form';
    } catch (error) {
      console.error('Error during form submission:', error);
      Sentry.captureException(error);
      toast.dismiss();
      toast.error('Sorry, something went wrong on our end. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="form-intake-questionnaire my-4">
      <Form
        onSubmit={handleSubmit}
        className={`intake-form-p2 ${showFormErrors ? 'validated' : ''}`}
        noValidate
      >
        <div className="form-section mt-5">
          <PatientStoryContactForm
            formData={formData}
            setFormData={setFormData}
            formErrors={{}}
            showFormErrors={showFormErrors}
          />
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </div>
      </Form>
    </Container>
  );
}
